export default __webpack_public_path__ + "static/media/login-page.d545e5b3.png";